import axios from "axios";

export const getEvents = (careersClientId, displayAll) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/events/" +
        encodeURIComponent(careersClientId) +
        "/" +
        encodeURIComponent(displayAll)
    )
    .then((res) => res.data);
};

export const deactivateEvent = (eventId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/events/deleteevent/" + encodeURIComponent(eventId)
    )
    .then((res) => res.status);
};

export const saveEvent = (event) => {
  return axios
    .put(import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/events/saveEvent", event)
    .then((res) => res.status);
};

export const getRsvp = (eventId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/events/geteventrsvp/" + encodeURIComponent(eventId)
    )
    .then((res) => res.data);
};

export const exportRsvp = (eventId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/events/exportRsvp/" + encodeURIComponent(eventId),
      {
        headers: {
          "Content-Type": "text/csv",
        },
        responseType: "blob",
      }
    )
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "RSVP.csv");
      document.body.appendChild(link);
      link.click();
      return true;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

export const getScanner = (careersClientId, eventId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/events/getscannertokens/" +
        encodeURIComponent(careersClientId) +
        "/" +
        encodeURIComponent(eventId)
    )
    .then((res) => res.data);
};

export const generateScannerToken = (eventId) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/events/generatescannertoken/" +
        encodeURIComponent(eventId)
    )
    .then((res) => res.data);
};

export const getEvent = (careersClientId, eventId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/events/getevent/" +
        encodeURIComponent(careersClientId) +
        "/" +
        encodeURIComponent(eventId)
    )
    .then((res) => res.data);
};

export const activateEvent = (eventId) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/events/activateevent/" +
        encodeURIComponent(eventId)
    )
    .then((res) => res.status);
};
